"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabeledIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function LabeledIcon(props) {
    const { children, className, width = 40, height = 40 } = props, rest = __rest(props, ["children", "className", "width", "height"]);
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "$width": width, "data-e2e": 'LabeledIcon_Container', children: [(0, jsx_runtime_1.jsx)(StyledIcon, Object.assign({ width: width, height: height }, rest, { "data-e2e": 'LabeledIcon_StyledIcon' })), children] }));
}
exports.LabeledIcon = LabeledIcon;
const Container = styled_components_1.default.div `
  display: inline-block;
  max-width: ${props => props.$width + 85}px;

  color: ${props => props.theme.text};
  font-size: 16px;
  text-align: center;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  display: block;
  margin: 0 auto 15px;
`;
